import { useEffect } from "react";
import { useDispatch, useStore } from "../store";
import { fetchFullTextLinks } from "../store/actions";
import { logTopicFullTextLinkClicked } from "../util/analytics";

export default function useFtLinks(docId, docType, telemetryData) {
  const { ftLinks } = useStore();
  const dispatch = useDispatch();

  useEffect(() => {
    logTopicFullTextLinkClicked(telemetryData);
    fetchFullTextLinks(dispatch, docId, docType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, docId, docType]);

  return {
    ftLinks,
  };
}
